import { Box } from '@mui/material'
import { useContext } from 'react'
import { LanguageContext } from '../util/LanguageContext'
import { VersionContext } from '../util/VersionContext'

export const Footer = () => {
  const translation = useContext(LanguageContext)
  const { version } = useContext(VersionContext)
  const uri = new URL(window.location.href)
  const getCompany: () => 'TA' | 'KC' = () => {
    const hostname = uri.hostname
    if (
      process.env.REACT_APP_DOMAIN_TA &&
      hostname.includes(process.env.REACT_APP_DOMAIN_TA || '')
    ) {
      return 'TA'
    }
    return 'KC'
  }
  const company = getCompany()

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '16px',
        left: '16px',
        right: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        font: 'normal normal normal 12px/12px Noto Sans JP',
        pointerEvents: 'none',
      }}
    >
      {/* コピーライトが異なる場合は切替できるようにしておく(現状同じ) */}
      <Box>{company === 'TA' ? translation['copyright_info'] : translation['copyright_info']}</Box>

      {/* バージョン情報 */}
      <Box sx={{ color: '#999999' }}>
        {version ? `${translation['app_version']}`.replace('{version}', version) : ''}
      </Box>
    </Box>
  )
}
